import { Widget } from "instantsearch.js";
import { MeiliSearchMultiSearchParams } from "@meilisearch/instant-meilisearch";


export function getPageParams({ page, hitsPerPage, hitsPerPageFirst }: {
    page: MeiliSearchMultiSearchParams['page'],
    hitsPerPageFirst: number,
    hitsPerPage: number,
}): Partial<MeiliSearchMultiSearchParams> {
    return {
        hitsPerPage: undefined,
        page: undefined,
        offset: page && page > 1 ? hitsPerPageFirst + hitsPerPage * (page - 2) : 0,
        limit: page && page > 1 ? hitsPerPage : hitsPerPageFirst,
    }
}

export function customHitsPerPage({ hitsPerPage, hitsPerPageFirst }: { hitsPerPage: number, hitsPerPageFirst: number }): Widget {
    const definition: Widget = {
        $$type: 'customHitsPerPage',
        init({ helper, renderState }) {
        },
        getWidgetSearchParameters(searchParameters, { uiState }) {
            searchParameters.hitsPerPage = hitsPerPageFirst;
            // console.log('getWidgetSearchParameters', searchParameters);
            return searchParameters;
        },
        getRenderState(state, { helper, results }) {
            // console.log('getRenderState',helper.lastResults?.page);
            return state;
        },
        getWidgetRenderState({ helper }) {
            // console.log('getWidgetRenderState',helper.lastResults?.page);
            return {
                widgetParams: { hitsPerPage, hitsPerPageFirst }
            }
        },
        getWidgetUiState(uiState, { searchParameters, helper }) {
            helper.overrideStateWithoutTriggeringChangeEvent({
                ...helper.state,
                hitsPerPage: searchParameters.page && searchParameters.page > 0 ? hitsPerPage : hitsPerPageFirst,
            });
            console.log(helper.state);
            return uiState;
        },
        dispose() {
        },
    }
    return definition;
}
